'use client';

import { useAuth } from '@clerk/clerk-react';
import { useInfiniteQuery } from '@tanstack/react-query';

import { apiClient } from '../api/client';

// INVOICES_PAGE_SIZE matches the backend default page size; each "load more"
// fetches the next cursor-paginated page of this size.
const INVOICES_PAGE_SIZE = 24;

export function useInvoices() {
  const {
    getToken,
    isLoaded,
    isSignedIn,
    orgId: clerkOrganizationId,
  } = useAuth();

  return useInfiniteQuery({
    queryKey: ['invoices', clerkOrganizationId],
    enabled: isLoaded && isSignedIn === true && !!clerkOrganizationId,
    initialPageParam: '',
    queryFn: async ({ pageParam }) => {
      const token = await getToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const { data, error, response } = await apiClient.GET(
        '/api/v1/billing/invoices',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            query: {
              limit: INVOICES_PAGE_SIZE,
              ...(pageParam ? { startingAfter: pageParam } : {}),
            },
          },
        }
      );

      if (response.status === 404) {
        return null;
      }

      if (error || !data) {
        throw new Error('Failed to fetch invoices');
      }

      return data;
    },
    getNextPageParam: (lastPage) =>
      lastPage?.hasMore ? lastPage.nextCursor : undefined,
    retry: false,
  });
}
